import {
  buildRichTooltip,
  RICH_TOOLTIP_CLASS,
  tooltipField,
  tooltipTitle,
} from "../../../../../../../_shared/_logic/rich-tooltips"

export const INBOX_BATCH_ACTION_TOOLTIP_CLASS = RICH_TOOLTIP_CLASS

type InboxBatchActionTooltipParts = {
  title: string
  action: string
  effect: string
  prerequisite: string
}

export const inboxBatchActionTooltip = ({
  title,
  action,
  effect,
  prerequisite,
}: InboxBatchActionTooltipParts): string =>
  buildRichTooltip([
    tooltipTitle(title),
    tooltipField("Was passiert", action),
    tooltipField("Auswirkung", effect),
    tooltipField("Voraussetzung", prerequisite),
  ])

export const inboxBatchActionTooltipWithDisabledReason = (
  tooltipContent: string,
  disabledReason?: string | null,
): string =>
  disabledReason ? buildRichTooltip([tooltipField("Hinweis", disabledReason)]) : tooltipContent
